var DOC = document;

var CORE = {

	className: 'brtn-form__fgroup--password',

	elements: null,

	Button: function (btn) {

		var BUTTON = {

			$el: $(btn),

			visible: false,

			button: {

				className: 'brtn-form__fgroup--password__see',

				elements: null,

				onClick: function (e) {
					e.preventDefault();

					if (BUTTON.visible) {
						BUTTON.$el.removeClass(CORE.className + '--show');
						BUTTON.input.toggle();
						BUTTON.visible = false;
						return;
					}
					BUTTON.$el.addClass(CORE.className + '--show');
					BUTTON.input.toggle();
					BUTTON.visible = true;
				},

				construct: function () {
					var self = BUTTON.button;
					var elements = btn.getElementsByClassName(self.className);
					var i = 0;

					if (typeof elements !== 'object' || elements == null || !elements.length) {
						return;
					}
					self.elements = [];

					for (i; i < elements.length; i++) {
						self.elements[self.elements.length] = elements[i];
						elements[i].addEventListener('click', self.onClick);
					}

				}

			},


			input: {

				className: 'brtn-form__field',

				elements: null,

				toggle: function () {
					var els = BUTTON.input.elements;

					if (els === null) {
						return;
					}

					if (BUTTON.visible) {
						$(els).attr('type', 'password');
						return;
					}
					$(els).attr('type', 'text');

				},

				construct: function () {
					var self = BUTTON.input;
					var elements = btn.getElementsByClassName(self.className);
					var i = 0;

					if (typeof elements !== 'object' || elements == null || !elements.length) {
						return;
					}
					self.elements = [];

					for (i; i < elements.length; i++) {
						self.elements[self.elements.length] = elements[i];
					}

				}

			}

		};
		BUTTON.button.construct();
		BUTTON.input.construct();

	},

	construct: function () {
		var els = DOC.getElementsByClassName(CORE.className);
		var i = 0;

		if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
			return false;
		}
		CORE.elements = [];

		for (i; i < els.length; i++) {
			CORE.elements[CORE.elements.length] = els[i];
			CORE.Button(els[i]);
		}

	},

};

export default CORE.construct;